import {UNIQUE_PHARMACY} from "../pharmacyTypeDefs";
import {useQuery} from "@apollo/client";

export const useQueryUniquePharmacy = (options?: any): any => (
  useQuery(UNIQUE_PHARMACY, options)
);
